"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = Object.freeze({
  // Content types
  RICH_TEXT: 'richtext',
  TEXT: 'text',
  LOGO: 'logo',
  IMAGE: 'image',
  BUTTONS: 'buttons',
  FORM: 'form',
  BLOG_POST: 'blogpost',
  LISTS: 'lists',
  MENU: 'menu',
  CTA: 'cta',
  CODE: 'code',
  VIDEO: 'video',
  SLIDER: 'slider',
  ANIMATION: 'animation',
  ICON: 'icon',
  FEED: 'feed',
  ACCORDION: 'accordion',
  // Purposes
  BRANDING: 'branding',
  SETTINGS: 'settings',
  HEADERS: 'headers',
  SOCIAL: 'social',
  CONVERSION: 'conversion',
  INTERACTION: 'interaction',
  EMAIL: 'email',
  BLOG: 'blog',
  NAVIGATION: 'navigation',
  LAYOUT: 'layout',
  TRANSLATION: 'translation',
  SEARCH: 'search',
  GALLERY: 'gallery',
  BANNER: 'banner',
  CALCULATOR: 'calculator',
  MULTIMEDIA: 'multimedia',
  PROGRESS_BAR: 'progressbar',
  MAP: 'map',
  DEFAULT: 'DEFAULT'
});

exports.default = _default;
module.exports = exports.default;